import clsx from "clsx";
import React, { type JSX } from "react";

import type { InputProps } from "../../../interfaces/input";
import { LoadingSkeleton } from "../../LoadingSkeleton";
import { InputError } from "../InputError";

const formatPhoneNumber = (value: string) => {
  if (value.length <= 2) {
    return value;
  }

  if (value.length <= 6) {
    return value.replace(/(\d{2})(\d{0,4})/, "($1) $2");
  }

  if (value.length <= 10) {
    return value.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
  }

  return value.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3").slice(0, 15);
};

const formatEventValue = (event: React.ChangeEvent<HTMLInputElement>) => {
  const onlyDigits = event.target.value.replace(/\D/g, "");
  const value = formatPhoneNumber(onlyDigits);

  return {
    ...event,
    target: {
      ...event.target,
      value,
    },
  };
};

export const InputPhone = ({
  field,
  label,
  className,
  errorMessage,
  onChange,
  loadingValue,
  ...attributes
}: InputProps): JSX.Element => {
  return (
    <div className={clsx("flex flex-col", className)}>
      {label && (
        <label className={clsx("mb-1 lg:mb-0.5", attributes.disabled && "opacity-50")} htmlFor={field}>
          <b>{label}</b>
        </label>
      )}

      {loadingValue ? (
        <LoadingSkeleton kind="input" />
      ) : (
        <input
          {...attributes}
          type="text"
          onChange={(e) => {
            if (onChange) {
              onChange(formatEventValue(e));
            }
          }}
          className={clsx({ "outline-feedback-error": errorMessage })}
          id={field}
          name={field}
        />
      )}

      <InputError message={errorMessage} />
    </div>
  );
};
